<template>
    <b-card v-if="statistics">
        <h4>
            Statistics
            <b-badge style="float: right">
                <router-link :to="{name: 'guestsList', params: {event_id: event_id}}">
                    <i class="fa fa-users"></i>
                </router-link>
            </b-badge>
        </h4>
        <dl>
        <template cols="*" v-for="d in Object.keys(statistics)">
            <dt>{{d}}</dt>
            <dd>
                <small><b>guests:  </b>{{ statistics[d].guests }}</small>
                &nbsp;
                <small><b>partners: </b>{{ statistics[d].partners }}</small>
            </dd>
        </template>
        </dl>
    </b-card>
</template>

<script>
import axios from "axios";

export default {
    name: "guestStatistics",
    props: ["event_id"],
    data: () => {
        return {
            resources: {
                events: "/events",
                guests: "/guests",
                statistics: "/statistics"
            },
            statistics: null
        };
    },
    methods: {
        fetchData(resource, cb) {
            return axios
                .get(this.$store.getters.apiBase + this.$data.resources.events + "/" + this._props["event_id"] +
                    this.$data.resources.guests +  this.$data.resources.statistics, {
                    headers: {
                        "Content-Type": "application/json",
                        
                        Authorization: this.$store.getters.accessToken,
                        account_id: this.$store.getters.accountId
                    }
                })
                 .then(response => {
                    this.$data.statistics = response.data;
                    return response;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    watch: {
        "$route": "fetchData"
    },
    computed: {
        
    },
    created() {
        this.fetchData();
    }
};
</script>